import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ChangeQuestionTypeConfirmDialog = ({ open, onClose, onConfirm }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="change-question-type-confirm-title"
            maxWidth="sm"
            fullWidth
            sx={{ zIndex: 13001 }}
        >
            <DialogTitle id="change-question-type-confirm-title">
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    Confirm Question Type Change
                    <IconButton aria-label="close" onClick={onClose} size="small">
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Typography>
                    You changed the question type, so your auto fill settings will be disabled. Are you sure you want to proceed?
                </Typography>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', gap: 2, pb: 3, px: 3 }}>
                <Button
                    onClick={onClose}
                    variant="outlined"
                    sx={{ textTransform: 'none' }}
                >
                    No
                </Button>
                <Button
                    onClick={onConfirm}
                    variant="outlined"
                    color="primary"
                    sx={{ textTransform: 'none' }}
                >
                    Yes
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ChangeQuestionTypeConfirmDialog;
